import { useState } from 'react';
import api from "../services/axiosInstance";
import { useNavigate } from 'react-router';
import { useGlobalOpsi } from "../components/GlobalOpsi";
import { clearSessionToken, setSessionToken } from "../services/authSession";
import { APP_VERSION } from "../appVersion";
import './Login.css';

const REQ_GROUP_LOGIN_SUBMIT = 'auth-login-submit';

export default function Login() {
  const [u, setU] = useState('');
  const [p, setP] = useState('');
  const [err, setErr] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [capsLockOn, setCapsLockOn] = useState(false);
  const { refreshGlobalOpsi } = useGlobalOpsi();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setErr('');
    const username = String(u || '').trim();
    const password = String(p || '');
    if (!username || !password) {
      setErr('Data login tidak lengkap');
      return;
    }

    try {
      setIsSubmitting(true);
      api.cancelPendingRequests({
        group: REQ_GROUP_LOGIN_SUBMIT,
        reason: 'submit login terbaru',
      });
      const res = await api.post(`/api/auth/login`, { username, password }, {
        requestGroup: REQ_GROUP_LOGIN_SUBMIT,
        timeout: 15000,
      });
      api.cancelPendingRequests({ reason: 'refresh token setelah login sukses' });
      clearSessionToken();
      setSessionToken(res?.data?.token);
      setP('');
      localStorage.removeItem("globalOpsi");
      localStorage.removeItem("trigerVersion");
      try {
        await refreshGlobalOpsi();
      } catch (syncErr) {
        if (!api.isCanceledError(syncErr)) {
          console.error("Gagal sync master saat login:", syncErr);
        }
      }
      nav('/main');
    } catch (e) {
      if (api.isCanceledError(e)) return;
      console.log("login gagal");
      setErr(e.response?.data?.message || 'Login gagal');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-rings" aria-hidden="true">
        <svg viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="login-ring-one" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#31D6F4" stopOpacity=".66" />
              <stop offset="48%" stopColor="#11A3C5" stopOpacity=".48" />
              <stop offset="100%" stopColor="#14758C" stopOpacity=".20" />
            </linearGradient>
            <linearGradient id="login-ring-two" x1="1" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#5367FF" stopOpacity=".56" />
              <stop offset="52%" stopColor="#278DB2" stopOpacity=".42" />
              <stop offset="100%" stopColor="#0A5A72" stopOpacity=".18" />
            </linearGradient>
          </defs>
          <g className="login-ring-spin">
            <circle className="login-ring" cx="400" cy="400" r="352" stroke="url(#login-ring-one)" strokeWidth="26" pathLength="1" style={{ strokeDasharray: '.76 .24', animationDelay: '.05s' }} />
            <circle className="login-ring" cx="400" cy="400" r="306" stroke="url(#login-ring-two)" strokeWidth="18" pathLength="1" style={{ strokeDasharray: '.7 .3', animationDelay: '.18s' }} />
            <circle className="login-ring" cx="400" cy="400" r="266" stroke="url(#login-ring-one)" strokeWidth="11" pathLength="1" style={{ strokeDasharray: '.64 .36', animationDelay: '.31s' }} />
            <circle className="login-ring" cx="400" cy="400" r="232" stroke="#38C7D9" strokeOpacity=".38" strokeWidth="7" pathLength="1" style={{ strokeDasharray: '.57 .43', animationDelay: '.44s' }} />
            <circle className="login-ring" cx="400" cy="400" r="203" stroke="#6576FF" strokeOpacity=".34" strokeWidth="3.5" pathLength="1" style={{ strokeDasharray: '.5 .5', animationDelay: '.57s' }} />
          </g>
        </svg>
      </div>

      <section className="login-card" aria-label="Form login">
        <img className="login-logo" src="/LogoPUA.png" alt="PT Putra Utama Anda — Tyre Management System" />
        <h1>LOGIN</h1>
        <form onSubmit={submit} autoComplete="off" noValidate>
          <div className="login-field">
            <label htmlFor="username">Username</label>
            <div className={`login-box ${err && !u.trim() ? 'bad' : ''}`}>
              <input id="username" name="username" type="text" placeholder="username" autoComplete="username" autoCapitalize="none" spellCheck="false" value={u} onChange={(e) => { setU(e.target.value); setErr(''); }} required />
            </div>
          </div>
          <div className="login-field">
            <label htmlFor="password">Password</label>
            <div className={`login-box ${err && !p ? 'bad' : ''}`}>
              <input id="password" name="password" type={showPassword ? 'text' : 'password'} placeholder="••••••••" autoComplete="new-password" value={p} onChange={(e) => { setP(e.target.value); setErr(''); }} onKeyDown={(e) => setCapsLockOn(e.getModifierState?.('CapsLock') || false)} onKeyUp={(e) => setCapsLockOn(e.getModifierState?.('CapsLock') || false)} onBlur={() => setCapsLockOn(false)} required />
              <button type="button" className="login-peek" onClick={() => setShowPassword((shown) => !shown)} aria-pressed={showPassword} aria-label={showPassword ? 'Sembunyikan password' : 'Tampilkan password'}>{showPassword ? 'Tutup' : 'Lihat'}</button>
            </div>
            {capsLockOn && <p className="login-caps">Caps Lock sedang aktif.</p>}
          </div>
          {err && <p className="login-msg" role="alert">{err}</p>}
          <button type="submit" className="login-go" aria-busy={isSubmitting} disabled={isSubmitting}>{isSubmitting ? 'Menghubungkan' : 'LOGIN'}</button>
        </form>
        <p className="login-version">versi <b>{APP_VERSION}</b></p>
      </section>
    </main>
  );
}
